
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>资讯分类管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">


      <el-form-item label="筛选：">
        <el-select v-model="classifyId" placeholder="选择一级分类" @change="changeClassify">
          <el-option
            v-for="item in newsClassifyList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="">
        <el-input size="small" v-model="formInline.roleNo" placeholder="输入角色代码"></el-input>
      </el-form-item> -->
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column sortable prop="name" label="分类名称" width="300">
      </el-table-column>

      <el-table-column sortable prop="commission" label="抽点%" width="300">
      </el-table-column>


      


      <el-table-column prop="name" label="图片" width="120"> 

        <template slot-scope="scope">
          <img style="width: 90px;height: 90px;" :src="$adminImageUrl(scope.row.picture)">
        </template>

      </el-table-column>
      <!-- <el-table-column sortable prop="roleNo" label="角色代码" width="300">
      </el-table-column> -->
      <!-- <el-table-column sortable prop="editTime" label="修改时间" width="300">
        <template slot-scope="scope">
          <div>{{scope.row.editTime|timestampToTime}}</div>
        </template>
      </el-table-column> -->
      <el-table-column sortable prop="createTime" label="创建时间" width="300">
        <template slot-scope="scope">
          <div>{{transformDate(scope.row.createTime)}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="status" label="状态" width="120">
        <template slot-scope="scope">
          <el-tag :type="Number(scope.row.status) === 1 ? 'info' : 'success'">
            {{ Number(scope.row.status) === 1 ? '已下架' : '已上架' }}
          </el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column sortable prop="editUser" label="修改人" width="300">
      </el-table-column> -->
      <el-table-column align="center" label="操作" min-width="300">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button
            size="mini"
            :type="Number(scope.row.status) === 1 ? 'success' : 'warning'"
            @click="toggleStatus(scope.row)"
          >{{ Number(scope.row.status) === 1 ? '上架' : '下架' }}</el-button>
          <el-button size="mini" type="danger" @click="deleteNewsClassifyTwo(scope.$index, scope.row)">删除</el-button>
          <!-- <el-button size="mini" type="success" @click="menuAccess(scope.$index, scope.row)">菜单权限</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog
      :title="title"
      :visible.sync="editFormVisible"
      width="90%"
      top="5vh"
      :modal="false"
      :close-on-click-modal="false"
      custom-class="news-classify-dialog"
      @opened="onDialogOpened"
      @click='closeDialog("edit")'>
      <el-form label-width="120px" ref="editForm" class="editor-dialog-form">
     
        <el-form-item label="分类名称" prop="roleName">
          <el-input ref="nameInput" size="small" v-model="name" auto-complete="off" placeholder="请输入分类名称"></el-input>
        </el-form-item>
        <el-form-item label="抽点%" prop="commission">
          <el-input size="small" v-model="commission" auto-complete="off" placeholder="请输入抽点"></el-input>
        </el-form-item>
        <el-form-item label="界面排版类型，1按摩的排版" prop="type">
          <el-input size="small" v-model="type" auto-complete="off" placeholder="请输入类型"></el-input>
        </el-form-item>
        <el-form-item label="1限制添加数量" prop="type">
          <el-input size="small" v-model="isRestrict" auto-complete="off" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="技能介绍" prop="introduce">
          <quill-editor
            ref="introduceEditor"
            v-model="introduce"
            class="rich-editor"
            :options="introduceEditorOption"
            @ready="onEditorReady('introduceEditor')"
            @focus="setActiveEditor('introduceEditor')">
          </quill-editor>
        </el-form-item>
        <el-form-item label="购买需知" prop="buyingKnowledge">
          <quill-editor
            ref="buyingKnowledgeEditor"
            v-model="buyingKnowledge"
            class="rich-editor"
            :options="buyingKnowledgeEditorOption"
            @ready="onEditorReady('buyingKnowledgeEditor')"
            @focus="setActiveEditor('buyingKnowledgeEditor')">
          </quill-editor>
        </el-form-item>
        <el-form-item label="评价标签" prop="evaluateTag">
          <el-input size="small" v-model="evaluateTag" auto-complete="off" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="图片" style="">

            <div class="upload-demo">
                  <el-upload
                  action=""
                  :http-request="mainImgUpload"
                  :show-file-list="false"
                  list-type="picture-card" >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <img v-if="picture" :src="$adminImageUrl(picture)" class="avatar">
     
            </div>
                
          </el-form-item> 


          <div  v-for="(item,i) in customData" >
             <span style="font-weight: 600;" >{{i+1}}.{{item.name}}</span><span style="color: blue; padding-left: 40px;" @click="deleteCustomData(i)"  >删除</span>
          </div>


      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="open()" >添加自定义字段</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="addNewsClassifyTwo()" v-if="title=='添加'">添加</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="upNewsClassifyTwo()" v-if="title=='修改'">修改</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { 
  



getNewsClassifyList,

addNewsClassifyTwo,
upNewsClassifyTwo,
deleteNewsClassifyTwo,
getNewsClassifyTwoList,




 } from "../../api/userMG";
import Pagination from "../../components/Pagination";
import client from "@/utils/ossClient.js";


import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

// 工具栏配置
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // toggled buttons
  ["blockquote", "code-block"],

  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }], // superscript/subscript
  [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
  [{ direction: "rtl" }], // text direction

  [{ size: ["small", false, "large", "huge"] }], // custom dropdown
  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ font: [] }],
  [{ align: [] }],
  ["link", "image", "video"], // 对于图片上传这是重点
  ["clean"], // remove formatting button
];



export default {
  data() {
    return {
      activeEditorRef: "introduceEditor",
      introduceEditorOption: null,
      buyingKnowledgeEditorOption: null,

      id: "", //当前操作的id
      searchKey: "", //搜索的关键字
      name: "", //名字
      picture:"",
      customData:[],
      commission:"",
      introduce:"",
      buyingKnowledge:"",
      evaluateTag:"",
      isRestrict:0,
      status:0,


      type:0,

      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      menuAccessshow: false, //控制数据权限显示与隐藏
      title: "添加",

      // 删除
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },

      listData: [], //用户数据
      // 选中
      checkmenu: [],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },

      classifyId:"",
      newsClassifyList:[],



    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  watch: {},

  /**
   * 创建完毕
   */

  created() {
    this.introduceEditorOption = this.createEditorOption("introduceEditor");
    this.buyingKnowledgeEditorOption = this.createEditorOption("buyingKnowledgeEditor");
    this.getNewsClassifyList()
  },

  /**
   * 里面的方法只有被调用才会执行
   */

  methods: {
    createEditorOption(editorRef) {
      return {
        placeholder: "请输入内容",
        modules: {
          toolbar: {
            container: toolbarOptions,
            handlers: {
              image: () => this.handleEditorImageUpload(editorRef),
            },
          },
        },
      };
    },
    setActiveEditor(editorRef) {
      this.activeEditorRef = editorRef;
    },
    onDialogOpened() {
      this.focusPrimaryField();
    },
    focusPrimaryField() {
      this.$nextTick(() => {
        const input = this.$refs.nameInput;
        if (input && typeof input.focus === "function") {
          input.focus();
          return;
        }
        const quill = this.getEditorInstance("introduceEditor");
        if (!quill) return;
        quill.focus();
        const index = Math.max(quill.getLength() - 1, 0);
        quill.setSelection(index, 0);
      });
    },
    onEditorReady(editorRef) {
      this.$nextTick(() => {
        const quill = this.getEditorInstance(editorRef);
        if (!quill) return;
        quill.enable(true);
      });
    },
    getEditorInstance(editorRef) {
      const target = this.$refs[editorRef];
      if (!target) return null;
      return Array.isArray(target) ? target[0].quill : target.quill;
    },
    async handleEditorImageUpload(editorRef) {
      const targetRef = editorRef || this.activeEditorRef;
      this.setActiveEditor(targetRef);
      const input = document.createElement("input");
      input.type = "file";
      input.accept = "image/png,image/jpeg,image/jpg,image/webp,image/bmp";
      input.click();
      input.onchange = async () => {
        const file = input.files && input.files[0];
        if (!file) return;
        const tmpcnt = file.name.lastIndexOf(".");
        const exname = file.name.substring(tmpcnt + 1).toLowerCase();
        const names = ["jpg", "jpeg", "webp", "png", "bmp"];
        if (names.indexOf(exname) < 0) {
          this.$message.error("不支持的格式!");
          return;
        }
        try {
          const fileName = `${Date.now()}_${file.uid || Math.random().toString(36).slice(2)}.${exname}`;
          const res = await client.put(fileName, file);
          if (!res.url) {
            this.$message.error("图片上传失败");
            return;
          }
          this.insertImageToEditor(res.url, targetRef);
        } catch (error) {
          this.$message.error("图片上传失败");
        }
      };
    },
    insertImageToEditor(url, editorRef) {
      const quill = this.getEditorInstance(editorRef || this.activeEditorRef);
      if (!quill) return;
      const selection = quill.getSelection(true);
      const index = selection ? selection.index : quill.getLength();
      quill.insertEmbed(index, "image", url);
      quill.setSelection(index + 1);
    },
    deleteCustomData(i){
      var customData =[];

      for (let index = 0; index < this.customData.length; index++) {
        if (index!=i) {
          customData.push(this.customData[index])
        }
        
      }
      this.customData = customData;
    },
    open() {
        this.$prompt('请输入名称', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          
          this.customData.push({
            name:value,
            value:""

          })


        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });       
        });
      },
        //自定义上传方法..
    mainImgUpload(file) {

      //判断扩展名
      const tmpcnt = file.file.name.lastIndexOf(".");
      const exname = file.file.name.substring(tmpcnt + 1);
      const names = ["jpg", "jpeg", "webp", "png", "bmp"];
      if (names.indexOf(exname) < 0) {
        this.$message.error("不支持的格式!");
        return;
      }
      const fileName = file.file.uid + "." + exname;
      client
        .put(fileName, file.file)
        .then((res) => {
          if (res.url) {
            this.picture = res.url;
          } else {
            this.$message.error("文件上传失败");
          }
        })
        .catch((err) => {});
    },
    changeClassify(e){

      this.listData = []
      this.classifyId = e;
      this.getNewsClassifyTwoList()
    },

    // 添加分类
    addNewsClassifyTwo() {
      this.loading = true;
      addNewsClassifyTwo({
        name: this.name,
        parentId: this.classifyId,
        commission:this.commission,
        picture:this.picture,
        type:this.type,
        introduce: this.introduce,
        buyingKnowledge: this.buyingKnowledge,
        evaluateTag: this.evaluateTag,
        isRestrict: this.isRestrict,
        
        customData:JSON.stringify(this.customData)
      }).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.editFormVisible = false
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.getNewsClassifyTwoList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 修改
    upNewsClassifyTwo() {
      this.loading = true;
      var customData = JSON.stringify(this.customData);
      console.log("customData",customData)
      console.log("customData",this.customData)
      upNewsClassifyTwo({
        name: this.name,
        parentId: this.classifyId,
        picture:this.picture,
        commission:this.commission,
        customData:customData,
        updateTime:0,
        type:this.type,
        createTime:0,
        id: this.id,
        introduce: this.introduce,
        buyingKnowledge: this.buyingKnowledge,
        evaluateTag: this.evaluateTag,
        isRestrict: this.isRestrict,
        status: this.status,

      }).then((res) => {
        this.loading = false;

        if (res.code == 200) {
          this.editFormVisible = false
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.getNewsClassifyTwoList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 获取二级分类
    getNewsClassifyTwoList() {
      this.loading = true;

      getNewsClassifyTwoList({parentId:this.classifyId}).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.listData = res.data.list;
          

          return;
        }
        this.$message({
          type: "info",
          message: res.msg,
        });
      });
    },
    // 获取一级分类
    getNewsClassifyList() {
      this.loading = true;

      getNewsClassifyList().then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.newsClassifyList = res.data.list;
          this.classifyId = this.newsClassifyList[0].id
          this.getNewsClassifyTwoList()


          return;
        }
        this.$message({
          type: "info",
          message: res.msg,
        });
      });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getdata(parm.currentPage);
    },

    //显示编辑界面
    handleEdit: function (row) {
      console.log("row", row);
      this.editFormVisible = true;
      if (row != undefined && row != "undefined") {
        this.title = "修改";
        this.id = row.id;
        this.name = row.name;
        this.commission=row.commission;
        this.picture=row.picture;
        this.type=row.type;

        this.introduce=row.introduce || "";
        this.buyingKnowledge=row.buyingKnowledge || "";
        this.evaluateTag=row.evaluateTag;

        this.isRestrict=row.isRestrict;
        this.status=Number(row.status) === 1 ? 1 : 0;


        if (row.customData) {
          this.customData=JSON.parse(row.customData);
        }else{
          this.customData=[]
        }


        

        
      } else {
        this.title = "添加";
        this.name = "";
        this.commission = "";
        this.customData=[]

        this.introduce="";
        this.buyingKnowledge="";
        this.evaluateTag="";
        this.isRestrict=0;
        this.status=0;
        
      }
      this.$nextTick(() => {
        ["introduceEditor", "buyingKnowledgeEditor"].forEach((ref) => {
          const quill = this.getEditorInstance(ref);
          if (!quill) return;
          quill.enable(true);
          if (quill.root && quill.root.innerHTML === "<p>null</p>") {
            quill.setText("");
          }
        });
      });
    },

    toggleStatus(row) {
      const nextStatus = Number(row.status) === 1 ? 0 : 1;
      const action = nextStatus === 1 ? '下架' : '上架';
      this.$confirm(`确定${action}“${row.name}”吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        upNewsClassifyTwo({
          id: row.id,
          parentId: row.parentId,
          name: row.name,
          commission: row.commission,
          picture: row.picture,
          type: row.type,
          introduce: row.introduce || '',
          buyingKnowledge: row.buyingKnowledge || '',
          evaluateTag: row.evaluateTag || '',
          isRestrict: row.isRestrict,
          customData: row.customData || '[]',
          status: nextStatus
        }).then((res) => {
          if (res.code !== 200) {
            this.$message.error(res.msg || `${action}失败`);
            return;
          }
          row.status = nextStatus;
          this.$message.success(`${action}成功`);
        }).catch(() => {
          this.$message.error(`${action}失败`);
        }).finally(() => {
          this.loading = false;
        });
      }).catch(() => {});
    },

    // 删除
    deleteNewsClassifyTwo(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteNewsClassifyTwo({ id: row.id })
            .then((res) => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: "已删除！",
                });
                this.getNewsClassifyTwoList();
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              // this.$message.error("删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == "edit") {
        this.editFormVisible = false;
      } else if (dialog == "perm") {
        this.menuAccessshow = false;
      }
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.editor-dialog-form {
  width: 100%;
  box-sizing: border-box;
  max-height: 72vh;
  overflow-y: auto;
  padding-right: 12px;
}
.editor-dialog-form /deep/ .el-form-item__content {
  min-width: 0;
}
.rich-editor {
  width: 100%;
  background: #fff;
}
.rich-editor /deep/ .ql-toolbar.ql-snow {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  padding: 8px 10px;
  border: 1px solid #dcdfe6;
  border-bottom: none;
  border-radius: 6px 6px 0 0;
  background: #f8fafc;
}
.rich-editor /deep/ .ql-container.ql-snow {
  width: 100%;
  border: 1px solid #dcdfe6;
  border-radius: 0 0 6px 6px;
}
.rich-editor /deep/ .ql-editor {
  min-height: 180px;
  max-height: 260px;
  padding: 12px 14px;
  overflow-y: auto;
  line-height: 1.75;
  font-size: 14px;
  color: #303133;
}
.rich-editor /deep/ .ql-editor.ql-blank::before {
  color: #a8abb2;
  font-style: normal;
}
.rich-editor /deep/ .ql-snow .ql-picker {
  line-height: 24px;
}
</style>

 



// WEBPACK FOOTER //
// src/views/terrace/NewsClassifyTwo.vue